import { normalizeForSearch } from "./normalizeSearch";

export const buildNameMatcher = (rawSearch) => {
  const normalized = normalizeForSearch(rawSearch);
  const hasTrailingSpace = /\s$/.test(rawSearch);
  const tokens = normalized.trim().split(/\s+/).filter(Boolean);

  return (fullName) => {
    if (!tokens.length) return true;
    const nameWords = normalizeForSearch(fullName).split(/\s+/).filter(Boolean);
    if (!nameWords.length) return false;

    if (tokens.length === 1) {
      const token = tokens[0];
      if (hasTrailingSpace) {
        return nameWords.some((word) => word === token);
      }
      return nameWords.some((word) => word.startsWith(token));
    }

    if (nameWords.length < tokens.length) return false;

    for (let i = 0; i < tokens.length; i += 1) {
      const token = tokens[i];
      const word = nameWords[i] || "";
      const isLast = i === tokens.length - 1;
      if (isLast) {
        if (hasTrailingSpace) {
          if (word !== token) return false;
        } else if (!word.startsWith(token)) {
          return false;
        }
      } else if (word !== token) {
        return false;
      }
    }

    return true;
  };
};
